import { render, staticRenderFns } from "./PersistDocuments.vue?vue&type=template&id=87e5d730&scoped=true&"
import script from "./PersistDocuments.vue?vue&type=script&lang=js&"
export * from "./PersistDocuments.vue?vue&type=script&lang=js&"
import style0 from "./PersistDocuments.vue?vue&type=style&index=0&id=87e5d730&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e5d730",
  null
  
)

export default component.exports